import React from 'react';
import { ICacheContext } from 'framework/context/ICacheContext';
import { IEntPhysiciansSearchData } from 'gen/ApiClient';

export const EntPhysiciansFilterDataContext = React.createContext<ICacheContext<IEntPhysiciansSearchData>>(undefined as any);
